// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-24Dpa";
var _3 = "info-2h4Nf";
var _4 = "number-3aJBK";
var _5 = "compliment-374sO";
var _6 = "appreciation-1tPSj";
var _7 = "gratitude-p7GpA";
var _8 = "overlay-gcuwp";
var _9 = "header-1tj72";
export { _1 as "__esModule", _2 as "wrapper", _3 as "info", _4 as "number", _5 as "compliment", _6 as "appreciation", _7 as "gratitude", _8 as "overlay", _9 as "header" }
export default { "__esModule": _1, "wrapper": _2, "info": _3, "number": _4, "compliment": _5, "appreciation": _6, "gratitude": _7, "overlay": _8, "header": _9 }
